import { render, staticRenderFns } from "./AdminAuditLogList.vue?vue&type=template&id=e45cd45e"
import script from "./AdminAuditLogList.vue?vue&type=script&lang=js"
export * from "./AdminAuditLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports